/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentBookingStateUpdate/view.blocks to change it.
import AppointmentStatus from './AppointmentStatus/index'
import AppointmentType from './AppointmentType/index'
import React from 'react'
import SourceTypes from './SourceTypes/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentBookingStateUpdate({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/AppointmentBookingStateUpdate"
  
}) {
  return (<React.Fragment
>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<AppointmentStatus
  viewPath={`${viewPath}/AppointmentStatus`}
/>
<SourceTypes
  viewPath={`${viewPath}/SourceTypes`}
/>
{children}
</React.Fragment>)
}